import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import Button from "designV2/components/Button";
import "./orderModals.css";

const PREPARED = gql`
  mutation prepareOrderByShopAdmin($orderId: ID!) {
    prepareOrderByShopAdmin(orderId: $orderId) {
      _id
    }
  }
`;

const readableError = (error) => {
  if (!error) return "";
  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    return error.graphQLErrors[0].message;
  }
  return error.message || "Something went wrong, please try again.";
};

const PrepareOrder = ({ orderId, close }) => {
  const [error, setError] = useState("");
  const [prepareOrderByShopAdmin, { loading }] = useMutation(PREPARED);

  const onSubmit = () => {
    if (loading) return;
    setError("");
    prepareOrderByShopAdmin({ variables: { orderId } })
      .then(() => close())
      .catch((err) => setError(readableError(err)));
  };

  return (
    <div className="orderModalBody">
      <p className="orderModalConfirmText">Mark this order as prepared and ready to go out?</p>

      {error && (
        <div className="dsFormMessage error" role="alert">
          {error}
        </div>
      )}

      <div className="orderModalActions">
        <Button onClick={close}>No</Button>
        <Button variant="primary" onClick={onSubmit} loading={loading}>
          Yes, prepared
        </Button>
      </div>
    </div>
  );
};

export default PrepareOrder;
